import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { InsurancePackage, InsurancePackageConfigPayload, InsurancePackagePayload } from '../models/insurance-package.interface';
import { PACKAGES_API_URL } from '../tokens/api.tokens';

@Injectable({ providedIn: 'root' })
export class InsurancePackageService {
  private readonly http = inject(HttpClient);

  constructor(@Inject(PACKAGES_API_URL) private apiUrl: string) {}

  getInsurancePackages() {
    return this.http.get<InsurancePackage[]>(`${this.apiUrl}/packages`);
  }

  getInsurancePackageById(packageId: string) {
    return this.http.get<InsurancePackage>(`${this.apiUrl}/packages/${packageId}`);
  }

  createInsurancePackage(payload: InsurancePackagePayload) {
    return this.http.post<InsurancePackage>(`${this.apiUrl}/packages`, payload);
  }

  createEmptyInsurancePackage() {
    return this.http.post<InsurancePackage>(`${this.apiUrl}/packages/empty`, {});
  }

  deleteEmptyInsurancePackage(packageId: string) {
    return this.http.delete<InsurancePackage>(`${this.apiUrl}/packages/unactivated/${packageId}`);
  }

  editInsurancePackage(id: string, payload: InsurancePackagePayload) {
    return this.http.put<InsurancePackage>(`${this.apiUrl}/packages/${id}`, payload);
  }

  updateInsurancePackageConfig(packageId: string, payload: InsurancePackageConfigPayload) {
    return this.http.put(`${this.apiUrl}/packages/${packageId}/config`, payload);
  }

  deactivateInsurancePackage(id: string) {
    return this.http.delete<void>(`${this.apiUrl}/packages/${id}`);
  }

  activateInsurancePackage(id: string, payload: InsurancePackage) {
    return this.http.post<InsurancePackage>(`${this.apiUrl}/packages/${id}/activate`, {
      packageId: id,
      startDate: payload.startDate,
      endDate: payload.endDate,
    });
  }
}
